module.exports = __webpack_public_path__ + "static/027-bdb2d0a5f88ce27106734c7540767876.jpg";